import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, " Changes have been made to your diagnosis and/or procedure code sets. In order to save, please calculate the APR DRG ", -1)

import { ref } from 'vue';
import { useGrouperStore } from 'stores/grouper-store';
import {storeToRefs} from 'pinia';

const closeDelay = 15000;


export default /*#__PURE__*/_defineComponent({
  __name: 'CalculateAprBanner',
  props: {
    reopenDelay: { default: 500 }
  },
  setup(__props: any, { expose: __expose }) {

const showBanner = ref(false);
const grouperStore = useGrouperStore();
const { readOnly } = storeToRefs(grouperStore);
const props = __props;

let preventOpen = false;
let closeTimer: ReturnType<typeof setTimeout>;

function calculateAprDrg() {
  grouperStore.calculateApr();
}

function toggle(open: boolean) {
  if(!readOnly.value) {
    if (!open || !preventOpen) {
      showBanner.value = open;
    }

    if (open) {
      if (closeTimer) {
        clearTimeout(closeTimer);
      }
      closeTimer = setTimeout(() => {
        cancel();
      }, closeDelay);
    }
  }
}

function cancel() {
  preventOpen = true;
  toggle(false);
  setTimeout(() => {
    preventOpen = false
  }, props.reopenDelay);
}

__expose({
  toggle
});


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_banner = _resolveComponent("q-banner")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_banner, {
    class: "io-mfe-ig-calculate-banner",
    rounded: "",
    "inline-actions": ""
  }, {
    action: _withCtx(() => [
      _createVNode(_component_q_btn, {
        flat: "",
        unelevated: "",
        class: "io-mfe-ig-calculate-banner-calculate",
        onClick: calculateAprDrg
      }, {
        default: _withCtx(() => [
          _createTextVNode(" CALCULATE ")
        ]),
        _: 1
      }),
      _createVNode(_component_q_btn, {
        rounded: "",
        flat: "",
        unelevated: "",
        icon: "fa-solid fa-xmark",
        class: "io-mfe-ig-calculate-banner-cancel",
        onClick: cancel
      })
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 512)), [
    [_vShow, showBanner.value && _unref(grouperStore).aprCalcNeededForSubmit]
  ])
}
}

})